import { render, staticRenderFns } from "./AdminSolicitud.vue?vue&type=template&id=1a90c2b7&scoped=true&"
import script from "./AdminSolicitud.vue?vue&type=script&lang=js&"
export * from "./AdminSolicitud.vue?vue&type=script&lang=js&"
import style0 from "./AdminSolicitud.vue?vue&type=style&index=0&id=1a90c2b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a90c2b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
